var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3741_4913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.533333 3.50004C0.533333 2.32183 1.48846 1.36671 2.66667 1.36671H29.3333C30.5115 1.36671 31.4667 2.32183 31.4667 3.50004V19.5C31.4667 20.6782 30.5115 21.6334 29.3333 21.6334H2.66667C1.48846 21.6334 0.533333 20.6782 0.533333 19.5V3.50004Z",
    fill: "white",
    stroke: "#D1CEC7",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3741_4913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1631 7.88965H13.8369V15.6537H18.1631V7.88965Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1113 11.7717C14.1113 10.2628 14.8117 8.82244 15.9928 7.88966C13.8503 6.20242 10.7465 6.57279 9.05719 8.72642C7.36792 10.8663 7.73873 13.9665 9.89496 15.6537C11.6941 17.0666 14.2074 17.0666 16.0065 15.6537C14.8117 14.7209 14.1113 13.2806 14.1113 11.7717Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 11.7717C24 14.5015 21.7888 16.71 19.0558 16.71C17.9433 16.71 16.8721 16.3396 16.0068 15.6537C18.1493 13.9665 18.5201 10.8663 16.8309 8.7127C16.5837 8.41092 16.309 8.12285 16.0068 7.88966C18.1493 6.20242 21.2669 6.57279 22.9425 8.72642C23.6292 9.59062 24 10.6606 24 11.7717Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5331 14.8307V14.6661H23.6018V14.6387H23.437V14.6661H23.5057V14.8307H23.5331ZM23.849 14.8307V14.6387H23.7941L23.7392 14.7758L23.6842 14.6387H23.6293V14.8307H23.6705V14.6798L23.7254 14.8033H23.7666L23.8216 14.6798V14.8307H23.849Z",
    fill: "#F79E1B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3741_4913"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5C0 5.609 4.77563 0.833374 10.6667 0.833374H21.3333C27.2244 0.833374 32 5.609 32 11.5C32 17.3911 27.2244 22.1667 21.3333 22.1667H10.6667C4.77563 22.1667 0 17.3911 0 11.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3741_4913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 9.87654,
    fill: "white",
    transform: "translate(8 6.83337)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMc);
export default __webpack_public_path__ + "static/media/mc.f9336a9024f89c5f2d3987b35b57547e.svg";
export { ForwardRef as ReactComponent };